// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class ElectionYear {
    public static readonly ELECTION: string = 'Election';
    public static readonly NONELECTION: string = 'Non-Election';
    public static readonly NA: string = 'N/A';
    public static readonly SPECIAL: string = 'Special Election';
}
